const getExcerpt = (content) => {
  const firstParagraph = content.split("\n")[0];
  const tagsRemoved = firstParagraph.slice(3, -4);
  const whitespaceTrimmed = tagsRemoved.trim();
  const lengthTrimmed = whitespaceTrimmed.substring(0, 220);
  if (whitespaceTrimmed === lengthTrimmed) {
    return whitespaceTrimmed;
  } else {
    return (lengthTrimmed + "\u2026");
  }
};

export {
  getExcerpt
};


// WEBPACK FOOTER //
// ./src/utils/index.js